/* eslint-disable import/prefer-default-export, import/no-cycle */

import isString from 'lodash/isString';
// import isEmpty from 'lodash/isEmpty';

import React, {
  useRef,
  useMemo,
  useCallback,
  // useContext,
  // forwardRef,
} from 'react';
import styled, { css } from 'styled-components';

import Admin from 'hive-admin';
import AntdRadio from 'antd/lib/radio';
import AntdIcon from 'antd/lib/icon';
import AntdDropdown from 'antd/lib/dropdown';
import AntdMenu from 'antd/lib/menu';

// import MonacoEditor from '@monaco-editor/react';

// import PageSingle from 'hive-admin/src/components/PageSingle';
// import Field from 'hive-admin/src/components/Field';
import FieldSortableList from 'hive-admin/src/components/FieldSortableList';

import { Types as MongooseTypes } from 'mongoose/browser';
// import { ObjectId } from 'bson';

import {
  MenuOutlined,
  FireOutlined,
  LinkOutlined,
  SettingOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
// import getFilterWithCol from '../../helpers/getFilterWithCol';

import Types from '../../modules/types';

// import copyToClipboard from '../../helpers/copyToClipboard';

import ContextMenu from './ContextMenu';

import {
  TargetableFieldsForm,
} from './Targetable';

import './index.less';

import './items';
import './effects';

const { ObjectId } = MongooseTypes;

const NodeHeadWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: baseline;
  &[data-active="true"] > .field-sortable-list-item-head > * {
    color: ${({ theme }) => theme.less.primaryColor} !important;
  }
`;

const NodeHeadSpacer = styled.div`
  display: flex;
  flex: 1;
  min-width: 15px;
`;

const NodeLabel = styled.div`
  display: flex;
  flex: 1;
  align-items: baseline;
  font-size: 16px;
  overflow: hidden;
  margin-left: 10px;
  transform: translate(0px, 2px);
  &[data-large-label="true"] {
    font-size: 20px;
  }
  ${({ onClick }) => onClick && css`
    cursor: pointer;
  `}
`;

// const NodeLabelSpacer = styled.span`
//   flex: 1;
// `;

const NodeLabelIconWrapper = styled.span`
  margin-right: 8px;
  color: ${({ theme }) => theme.less.primaryColor};
`;

const NodeLabelTitle = styled.span`
  display: inline;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-top: 0px;
  ${({ $italic }) => $italic && css`
    opacity: 0.8;
    font-size: 16px;
  `}
`;

const NodeLabelSubtitle = styled.span`
  display: flex;
  font-size: 14px;
  padding-left: 5px;
  opacity: 0.6;
  white-space: nowrap;
  padding-left: 8px;
`;

const NodeActions = styled.div`
  display: flex;
  /* gap: 10px; */
  align-items: center;
  gap: 10px;
`;

const NodeActionsSeparator = styled.div`
  width: 0px;
  height: 20px;
  border-right: 1px solid ${({ theme }) => theme.less.borderColor};
`;

const NodeFrameViewingSwitcherRadioGroup = styled(AntdRadio.Group)`
  line-height: 12px;
  opacity: 0.8;
  white-space: nowrap;
  span {
    font-size: 11px;
  }
  .anticon {
    font-size: 10px;
  }
  .ant-radio-button-wrapper {
    height: 20px;
    line-height: 17px;
    .ant-radio-button-inner {
      margin-right: 1pc;
    }
  }
`;

const NodeFrameViewingSwitcherRadioButton = styled(AntdRadio.Button)`
  .anticon {
    color: ${({ theme, $hasValue }) => $hasValue && theme.less.primaryColor};
  }
`;

const NodeHideIconWrapper = styled.div`
  font-size: 12px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  &[data-active="false"] {
    opacity: 0.2;
  }
  &:hover {
    color: ${({ theme }) => theme.less.primaryColor};
    opacity: 1;
    * {
      opacity: 1;
    }
  }
  &[data-active="false"]:after {
    content: "";
    position: absolute;
    display: block;
    width: 22px;
    height: 0px;
    border-bottom: 1px solid ${({ theme, color }) => (
      color || theme.less.textColor
    )};
    transform: translate(-5px, -10px) rotate(-45deg);
  }
`;

const NodeHideIcon = styled(AntdIcon)`
  opacity: 0.7;
  pointer-events: none;
`;

const NodeHideWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

function NodeHide({
  name,
  value = [],
  onChange,
  // type,
  supportsLayout,
  values,
  targetable,
  targetId,
}) {
  const onHideChange = useCallback(
    (event) => {
      if (onChange) {
        const itemValue = event.target.dataset.name;
        const newValue = (
          `${event.target.dataset.active}` === 'true'
          ? [...value, itemValue]
          : value.filter(testValue => testValue !== itemValue)
        );
        onChange(name, newValue);
      }
    },
    [name, value, onChange],
  );
  return (
    <NodeHideWrapper>
      {
        ['Mobile', 'Tablet', 'Desktop'].map((optionName) => {
          const frameSettingsName = (
            supportsLayout
            ? `frame_layout${optionName}`
            : null
          );
          return (
            <NodeHide.Item
              key={optionName}
              optionName={optionName}
              onChange={onChange}
              onHideChange={onHideChange}
              value={value}
              values={values?.[frameSettingsName]}
              frameSettingsName={frameSettingsName}
              supportsLayout={supportsLayout}
              targetable={targetable}
              targetId={targetId}
            />
          );
        })
      }
    </NodeHideWrapper>
  );
}

NodeHide.Item = React.memo(
  ({
    optionName,
    onHideChange,
    overriden,
    // onChange,
    value,
    // values,
    // supportsLayout,
    // frameSettingsName,
    // targetable,
    // targetId,
  }) => {
    const icon = optionName.toLowerCase();
    const itemValue = optionName.toUpperCase();
    const render = useMemo(
      () => (
        <NodeHideIconWrapper
          key={itemValue}
          data-name={itemValue}
          data-active={!value.includes(itemValue)}
          title={optionName}
          onClick={onHideChange}
        >
          <NodeHideIcon
            type={icon}
            style={{ color: overriden ? 'red' : undefined }}
            color={overriden ? 'red' : undefined}
          />
        </NodeHideIconWrapper>
      ),
      [icon, itemValue, value, overriden, onHideChange, optionName],
    );
    return render;
  },
);

const NodeFrameViewSwitcher = ({
  name,
  values,
  onChange: onChangeOriginal,
  prefix,
}) => {
  const value = values?.[name] || 'content';
  const onChange = useCallback(
    event => onChangeOriginal(name, event.target.value),
    [name, onChangeOriginal],
  );
  const counts = useMemo(
    // eslint-disable-next-line arrow-body-style
    () => {
      const keyEffects = `${prefix}effects`;
      const keyEffectsHover = `${prefix}effectsHover`;
      return {
        effects: values?.[keyEffects]?.length || 0,
        effectsHover: values?.[keyEffectsHover]?.length || 0,
      };
    },
    [values, prefix],
  );
  return (
    <NodeFrameViewSwitcher.Pure
      name={name}
      value={value}
      counts={counts}
      onChange={onChange}
    />
  );
};

NodeFrameViewSwitcher.Pure = React.memo(
  // eslint-disable-next-line no-unused-vars
  ({ name, value, counts, onChange }) => (
    <NodeFrameViewingSwitcherRadioGroup
      size="small"
      onChange={onChange}
      value={value}
    >
      <NodeFrameViewingSwitcherRadioButton
        value="content"
      >
        <MenuOutlined />
        {' '}
        Content
      </NodeFrameViewingSwitcherRadioButton>
      <NodeFrameViewingSwitcherRadioButton
        value="effects"
        $hasValue={counts.effects > 0}
      >
        <FireOutlined />
        {' '}
        Effects
      </NodeFrameViewingSwitcherRadioButton>
      <NodeFrameViewingSwitcherRadioButton
        value="effectsHover"
        $hasValue={counts.effectsHover > 0}
      >
        <LinkOutlined />
        {' '}
        Hover
      </NodeFrameViewingSwitcherRadioButton>
    </NodeFrameViewingSwitcherRadioGroup>
  ),
);

const NodeSettingsButton = styled(SettingOutlined)`
  font-size: 14px;
  /* padding: 2px; */
`;

const NodeDeleteButton = styled(DeleteOutlined)`
  font-size: 14px;
`;

export function NodeHead({
  type,
  name,
  label,
  index,
  sidebarFields,
  value,
  onChange,
  onRemove,
  onSidebarChange,
  // headerToplevelActions,
  headerDropdownActions,
  itemIsActive,
  setItemIsActive,
  largeLabel,
  targetable,
  targetId,
  getSupportsEffects,
  getSupportsMediaQueries,
  getSupportsLayout,
  getSupportsHtmlTag,
  getSupportsSettings,
  // getSupportsTargeting,
  // items = [],
  itemsLabelsMap = {},
  itemsIconsMap = {},

  client,
  viewer,
  storage,
}) {
  const LabelIcon = (
    itemsIconsMap[type]
    || itemsIconsMap['*']
    || null
  );
  let nameTrimmed = (
      isString(name)
    ? name.trim()
    : null
  );
  let nameIsLabel = false;
  if (nameTrimmed === null || nameTrimmed.length === 0) {
    nameIsLabel = true;
    nameTrimmed = (
      isString(label)
      ? label.trim()
      : null
    );
    if (nameTrimmed === null || nameTrimmed.length === 0) {
      nameTrimmed = null;
    }
  }
  const labelTitle = (
    nameTrimmed
    ? nameTrimmed
    : itemsLabelsMap[type || '*']
  );
  const labelSubtitle = `${(
      (nameTrimmed && !nameIsLabel)
    ? (label || itemsLabelsMap[type || '*'])
    : ''
  )}`;
  const [
    supportsEffects,
    supportsMediaQueries,
    supportsLayout,
    supportsSettings,
    supportsHtmlTag,
    // supportsTargeting,
  ] = useMemo(
    () => [
      !getSupportsEffects ? false : getSupportsEffects(type),
      !getSupportsMediaQueries ? false : getSupportsMediaQueries(type),
      !getSupportsLayout ? false : getSupportsLayout(type),
      !getSupportsSettings ? false : getSupportsSettings(type),
      !getSupportsHtmlTag ? false : getSupportsHtmlTag(type),
      // !getSupportsTargeting ? false : getSupportsTargeting(type),
    ],
    [
      type,
      getSupportsEffects,
      getSupportsMediaQueries,
      getSupportsLayout,
      getSupportsSettings,
      getSupportsHtmlTag,
      // supportsTargeting,
    ],
  );
  // const [sidebarVisible, setSidebarVisible] = useState(false);
  const actionSidebarCompiled = useMemo(
    () => (
      supportsSettings && sidebarFields?.length > 0
      ? Admin.compileFromLibrary(['ActionWithConnectedFormSidebar', {
          title: 'Sidebar',
          label: null,
          name: 'frame_layout_action',
          // eslint-disable-next-line arrow-body-style
          renderAction: (props, action) => {
            return (
              <NodeSettingsButton
                key={props.name || props.id}
                onClick={action.handleClick}
              />
            );
          },
          ActionWithFormModalFormComponent: TargetableFieldsForm,
          fields: sidebarFields,
        }])
      : null
    ),
    [supportsSettings, sidebarFields],
  );
  return (
    <NodeHeadWrapper className="node-head-wrapper">
      <ContextMenu
        renderContextMenu={() => (
          <AntdDropdown
            destroyPopupOnHide
            mouseEnterDelay={0.01}
            overlay={(
              <AntdMenu>
                {
                  headerDropdownActions.map((item) => (
                    item.divider
                    ? <AntdMenu.Divider key={item.key} />
                    : (
                        <AntdMenu.Item key={item.key} onClick={item.onClick}>
                          <span>
                            {item.icon}
                            &nbsp;
                            {item.label}
                          </span>
                        </AntdMenu.Item>
                      )
                  ))
                }
              </AntdMenu>
            )}
          />
        )}
      >
        <NodeLabel
          data-large-label={!!largeLabel}
          onClick={
              actionSidebarCompiled
            ? () => setItemIsActive(true)
            : headerDropdownActions?.length
            ? () => {}
            : undefined
          }
        >
          {
            LabelIcon
            ? (
                <NodeLabelIconWrapper>
                  <LabelIcon />
                </NodeLabelIconWrapper>
              )
            : null
          }
          {/* <NodeLabelTitle
            onClick={(ev) => {
              sidebar.setActive(
                sidebar.active === value.__uid
                ? null
                : value.__uid
              );
            }}
          > */}
          <NodeLabelTitle data-is-label-title>
            {labelTitle}
          </NodeLabelTitle>
          <NodeLabelSubtitle>
            {labelSubtitle || null}
          </NodeLabelSubtitle>
          <NodeHeadSpacer />
        </NodeLabel>
      </ContextMenu>
      <NodeActions>
        {
          supportsEffects
          ? (
              <>
                <NodeFrameViewSwitcher
                  name="_viewing"
                  prefix={
                    type === 'FRAME'
                    ? 'frame_'
                    : type === 'TEXT'
                    ? 'text_'
                    : null
                  }
                  values={value}
                  onChange={onChange}
                />
                <NodeActionsSeparator />
              </>
            )
          : null
        }
        {
          supportsMediaQueries
          ? (
              <NodeHide
                name="hide"
                value={value?.hide}
                onChange={onChange}
                values={value}
                supportsLayout={supportsLayout}
                targetable={targetable}
                targetId={targetId}
                type={type}
              />
            )
          : null
        }
        <NodeActionsSeparator />
        {
          supportsLayout || (supportsSettings && actionSidebarCompiled)/* || supportsTargeting */
          ? (
              supportsSettings && actionSidebarCompiled
              ? (
                  actionSidebarCompiled.render({
                    client,
                    viewer,
                    storage,
                    data: value,
                    onSidebarChange,
                    modalControlled: true,
                    modalVisible: itemIsActive,
                    onModalVisibleChange: (sidebarVisibleNew) => (
                      setItemIsActive(!!sidebarVisibleNew)
                    ),
                    supportsEffects,
                    supportsMediaQueries,
                    supportsLayout,
                    supportsSettings,
                    supportsHtmlTag,
                    supportsHoverTarget: supportsEffects,
                    supportsStichesCss: true,
                    targetable,
                    targetId,
                    contentBuilderTargetable: targetable,
                  })
                )
              : null
            )
          : null
        }
        <NodeDeleteButton onClick={() => onRemove(index)} />
      </NodeActions>
    </NodeHeadWrapper>
  );
}

function NodeHeadCached({
  index,
  type,
  name,
  label,
  values,
  onChange: onChangeOriginal,
  onRemove,
  toolbarProps,
  targetable,
  targetId,

  client,
  viewer,
  storage,

  sidebarFields,

  headerToplevelActions,
  headerDropdownActions,
  itemIsActive,
  setItemIsActive,
}) {
  const indexRef = useRef(index);
  indexRef.current = index;
  const valuesRef = useRef(values);
  valuesRef.current = values;
  const onChangeOriginalRef = useRef(onChangeOriginal);
  onChangeOriginalRef.current = onChangeOriginal;
  const onChange = useCallback(
    (inputName, value) => {
      if (onChangeOriginalRef.current) {
        onChangeOriginalRef.current(indexRef.current, {
          ...valuesRef.current,
          [inputName]: value,
        });
      }
    },
    [],
  );
  const onSidebarChange = useCallback(
    (changedValues = {}) => {
      if (onChangeOriginalRef.current) {
        onChangeOriginalRef.current(indexRef.current, {
          ...valuesRef.current,
          ...changedValues,
        });
      }
    },
    [],
  );
  return (
    <NodeHead
      index={index}
      type={type}
      name={name}
      label={label}
      value={valuesRef.current}
      onChange={onChange}
      onRemove={onRemove}
      {...toolbarProps}
      onSidebarChange={onSidebarChange}
      targetable={targetable}
      targetId={targetId}
      client={client}
      viewer={viewer}
      storage={storage}
      sidebarFields={sidebarFields}
      headerToplevelActions={headerToplevelActions}
      headerDropdownActions={headerDropdownActions}
      itemIsActive={itemIsActive}
      setItemIsActive={setItemIsActive}
    />
  );
}

const CONFIG = {
  isContentBuilderField: true,
  label: null,
  addButtonLabel: 'Add',
  supportDropdownActions: true,
  supportDuplicate: true,
  supportCopy: true,
  supportCut: true,
  supportNativePaste: true,
  supportCollapseAll: true,
  shouldRenderPlaceholder: true,
  condensed: true,
  // collapseFieldName: '__visible',
  collapseFieldName: '__collapsed',
  collapseLabelDefault: '',
  // FormComponent: PortalForm,
  FormComponent: TargetableFieldsForm,
  dynamicFields: true,
  head: 'horizontal',
  headMode: 'toolbar',
  targetable: false,
  generateNewItem: (props, field, key) => {
    const item = {
      _id: `${ObjectId()}`,
    };
    if (props.nodeType) {
      item['@node'] = props.nodeType;
    }
    if (key) {
      item.type = key;
    }
    return item;
  },
  getCopyRealm: (item, props) => `${props.copyRealm}${
    item.type
    ? `:${item.type}`
    : ''
  }${
      item.type === 'COMPONENT'
    ? `:${item.component_id}`
    : item.type === 'BLOCK'
    ? `:${item.block_id}`
    : ''
  }`,
  // eslint-disable-next-line no-unused-vars
  getPastePayload: (item, props, field) => {
    item = JSON.parse(JSON.stringify(item));
    const skipKeys = props.getDuplicateSkipKeys(item, props) || [];
    Types.traverse(item, (subItem) => {
      const node = subItem?.['@node'];
      if (node) {
        skipKeys.forEach((key) => { delete subItem[key]; });
        subItem._id = `${ObjectId()}`;
      }
    });
    // Types.traverseContentBuilderNodes(item, (subItem) => {
    //   skipKeys.forEach((key) => { delete subItem[key]; });
    //   subItem._id = `${ObjectId()}`;
    // });
    return item;
  },
  // eslint-disable-next-line no-unused-vars
  getDuplicateItem: (item, props, field) => {
    item = JSON.parse(JSON.stringify(item));
    const skipKeys = props.getDuplicateSkipKeys(item, props) || [];
    Types.traverse(item, (subItem) => {
      const node = subItem?.['@node'];
      if (node) {
        skipKeys.forEach((key) => { delete subItem[key]; });
        subItem._id = `${ObjectId()}`;
      }
    });
    // Types.traverseContentBuilderNodes(item, (subItem) => {
    //   skipKeys.forEach((key) => { delete subItem[key]; });
    //   subItem._id = `${ObjectId()}`;
    // });
    return item;
  },
  fields: [
    ['FieldHidden', {
      name: '__uid',
      initialValue: false,
    }],
  ],
};

export default class FieldContentBuilderNodes extends FieldSortableList {
  static create({ getFieldContentBuilderConfig, ...config }) {
    const field = super.create(config);
    if (getFieldContentBuilderConfig) {
      return getFieldContentBuilderConfig(field, config);
    }
    return field;
  }
}

Admin.addToLibrary(
  'FieldContentBuilderNodes',
  (
    {
      toolbarProps = {},
      ...config
    } = {},
  ) => FieldContentBuilderNodes.create({
    ...CONFIG,
    getHeadToolbar: (props) => {
      const { value: values = {}, onChange, index } = props;
      return (
        <NodeHeadCached
          index={index}
          type={values.type}
          name={values.name}
          label={values.label}
          values={values}
          onChange={onChange}
          onRemove={props.onRemove}
          toolbarProps={toolbarProps}
          targetable={props.contentBuilderTargetable}
          targetId={values._id}
          client={props.client}
          viewer={props.viewer}
          storage={props.storage}
          sidebarFields={props.sidebarFields}
          headerToplevelActions={props.headerToplevelActions}
          headerDropdownActions={props.headerDropdownActions}
          itemIsActive={props.itemIsActive}
          setItemIsActive={props.setItemIsActive}
        />
      );
    },
    ...config,
    fields: [
      ...CONFIG.fields,
      ...(config.fields || []),
    ],
  }),
);
